import { render, staticRenderFns } from "./user-panel.vue?vue&type=template&id=51ad8dcc&scoped=true&"
import script from "./user-panel.vue?vue&type=script&lang=js&"
export * from "./user-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ad8dcc",
  null
  
)

export default component.exports